interface Props {
    className?: string
    FillColor?: string
}

export default function Wallet({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M9.30153 3.35587C10.1946 2.37043 11.7429 2.37043 12.636 3.35587L12.6607 3.38321H18.4494C19.0273 3.38321 19.5 3.85131 19.5 4.43321V7.88321H20.25C21.4926 7.88321 22.5 8.89057 22.5 10.1332V19.1332C22.5 20.3758 21.4926 21.3832 20.25 21.3832H3.75C2.50736 21.3832 1.5 20.3758 1.5 19.1332V6.38321C1.5 4.72635 2.84315 3.38321 4.5 3.38321H9.27676L9.30153 3.35587ZM21 13.8832V10.1332C21 9.71899 20.6642 9.38321 20.25 9.38321H3V19.1332C3 19.5474 3.33579 19.8832 3.75 19.8832H20.25C20.6642 19.8832 21 19.5474 21 19.1332V15.3832H16.2C15.5373 15.3832 15 14.8459 15 14.1832C15 14.0175 15.1343 13.8832 15.3 13.8832H21ZM16.7389 7.88321L18 7.88321V4.88321H14.0201L16.7389 7.88321ZM4.5 4.88321C3.67157 4.88321 3 5.55478 3 6.38321C3 7.21163 3.67157 7.88321 4.5 7.88321H5.19863L7.91738 4.88321H4.5ZM11.5245 4.36315C11.2268 4.03467 10.7107 4.03467 10.413 4.36315L7.2231 7.88305H14.7144L11.5245 4.36315Z"
                fill={FillColor} />
        </svg>
    )
}
